import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=baa9c270&scoped=true&lang=pug&"
import script from "./Company.vue?vue&type=script&lang=ts&"
export * from "./Company.vue?vue&type=script&lang=ts&"
import style0 from "./Company.vue?vue&type=style&index=0&id=baa9c270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9c270",
  null
  
)

export default component.exports